import { Button, Flex, Show, Text } from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";
import ModalDrawer from "@components/ModalDrawer";
import FooterButtons from "@components/SuccessErrorModalBodyTemplate/components/FooterButtons";
import { ClaimType } from "@hooks/useClaims";
import { ReactNode } from "react";

interface DisclaimerProps {
  isOpen: boolean;
  onClose: () => void;
  onApprove: () => void;
  type: ClaimType;
  disclaimer: ReactNode;
  primaryBtnTxt?: string;
  secondaryBtnTxt?: string;
}

const Disclaimer = ({
  isOpen,
  onClose,
  onApprove,
  disclaimer,
  primaryBtnTxt = "Agree",
  secondaryBtnTxt = "Cancel",
}: DisclaimerProps) => {
  return (
    <ModalDrawer isOpen={isOpen} closeAlert={onClose}>
      <Flex
        padding={{ base: "24px 16px", md: "40px" }}
        flexDirection="column"
        width="100%"
        maxWidth={{ base: "100%", md: "600px" }}
        gap={{ base: "24px", md: "32px" }}
      >
        <Flex
          justifyContent={"space-between"}
          align={"center"}
          flexDir={{ base: "column-reverse", md: "row" }}
        >
          <Text
            fontSize={{ base: "16px", md: "18px" }}
            lineHeight={"24px"}
            fontWeight={"600"}
          >
            Disclaimer
          </Text>
          <Button
            variant="unstyled"
            display="flex"
            p={{ base: "1.5rem 0", md: 0 }}
            height="24px"
            onClick={onClose}
            _focus={{
              boxShadow: "none",
            }}
          >
            <Show above="md">
              <BaseImage
                height={24}
                width={24}
                alt="close"
                src="/assets/close.svg"
              />
            </Show>
            <Show below="md">
              <BaseImage
                height={4}
                width={20}
                alt="close"
                src="/assets/close_mobile.svg"
              />
            </Show>
          </Button>
        </Flex>
        {disclaimer}

        <FooterButtons
          secondaryBtnTxt={secondaryBtnTxt}
          onSubmitSecondary={onClose}
          primaryBtnTxt={primaryBtnTxt}
          onSubmitPrimary={onApprove}
        />
      </Flex>
    </ModalDrawer>
  );
};

export default Disclaimer;
